var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavewithplus17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 3.16667V4.83334H13.8333V7.33334H12.1667V4.83334H9.66667V3.16667H12.1667V0.666672H13.8333V3.16667H16.3333ZM13.8333 14.8333H2.16667V3.16667H7.16667V1.50001H2.16667C1.25 1.50001 0.5 2.25001 0.5 3.16667V14.8333C0.5 15.75 1.25 16.5 2.16667 16.5H13.8333C14.75 16.5 15.5 15.75 15.5 14.8333V9.83334H13.8333V14.8333ZM10.5 9.83334V13.1667H12.1667V9.83334H10.5ZM7.16667 13.1667H8.83333V6.5H7.16667V13.1667ZM5.5 13.1667V8.16667H3.83333V13.1667H5.5Z",
    fill: "#4B6681"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavewithplus17);
export default __webpack_public_path__ + "97120/static/media/savewithplus17.2c58cda48cf64c6629a9aa9d6ac3a358.svg";
export { ForwardRef as ReactComponent };